import { type FC } from 'react';

import { formatCost } from 'utils/clickme';
import { HELP_PAGE_BONUSES } from 'utils/constants/app';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import { Link, Text, useBreakpoint, VSpacing, VSpacingContainer } from '@hh.ru/magritte-ui';
import { ArrowSquareOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import BonusExpirationInfo from 'components/BalanceAndBonuses/BonusesCard/components/BonusExpirationInfo';
import CardTemplate from 'components/BalanceAndBonuses/CardTemplate/CardTemplate';

import { useSelector } from 'store/utils';

import styles from 'components/BalanceAndBonuses/BonusesCard/BonusesCard.module.less';

const Trls = {
    header: 'BalanceAndBonuses.BonusesCard.header',
    bonusInfo: 'BalanceAndBonuses.BonusesCard.body.bonusInfo',
    bonusMore: 'BalanceAndBonuses.BonusesCard.body.bonusMore',
};

export const BonusesCard: FC<{ loading?: boolean }> = ({ loading }) => {
    const bonusBalance = useSelector((state) => state.balance?.bonusBalance);
    const { isMobile } = useBreakpoint();
    const trl = useTrls();

    return (
        <CardTemplate
            loading={loading}
            mobileHeight={132}
            desktopHeight={201}
            hideDivider={isMobile}
            topContent={
                <>
                    <Text style="secondary" typography="label-2-regular">
                        {trl(Trls.header)}
                    </Text>
                    <VSpacing default={6} />
                    <div className={styles.bonusContentWrapper}>
                        <Text style="primary" typography="title-4-semibold" data-qa="bonus-card-bonus-balance">
                            {formatCost(bonusBalance, NON_BREAKING_SPACE)}
                        </Text>
                        <BonusExpirationInfo />
                    </div>
                </>
            }
            bottomContent={
                !isMobile && (
                    <VSpacingContainer default={8}>
                        <Text style="secondary" typography="label-2-regular">
                            {trl(Trls.bonusInfo)}
                        </Text>
                        <Link
                            mode="secondary"
                            href={HELP_PAGE_BONUSES}
                            target="_blank"
                            iconRight={<ArrowSquareOutlinedSize16 />}
                            style="neutral"
                        >
                            {trl(Trls.bonusMore)}
                        </Link>
                    </VSpacingContainer>
                )
            }
        />
    );
};
